import { render, staticRenderFns } from "./pageNotFound.vue?vue&type=template&id=085f235d&scoped=true&"
import script from "./pageNotFound.vue?vue&type=script&lang=js&"
export * from "./pageNotFound.vue?vue&type=script&lang=js&"
import style0 from "./pageNotFound.vue?vue&type=style&index=0&id=085f235d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "085f235d",
  null
  
)

export default component.exports